import React, { FC } from "react";
import { Space, Typography } from "antd";
import { Payment, PaymentStatus } from "@dewo/app/graphql/types";
import { PaymentStatusTag } from "@dewo/app/components/tags/PaymentStatusTag";
import { explorerLink } from "./hooks";
import { ClearTaskRewardPaymentButton } from "../task/board/ClearTaskRewardPaymentButton";
import { usePermission } from "@dewo/app/contexts/PermissionsContext";
import { ExportOutlined } from "@ant-design/icons";

interface Props {
  payment: Payment;
}

export const PaymentRow: FC<Props> = ({ payment }) => {
  const canClear = usePermission("delete", "TaskReward");
  return (
    <>
      <Space direction="vertical" size={4}>
        <PaymentStatusTag status={payment.status} />
        {canClear && payment.status !== PaymentStatus.CONFIRMED && (
          <ClearTaskRewardPaymentButton payment={payment}>
            Clear transaction
          </ClearTaskRewardPaymentButton>
        )}
        <a target="_blank" href={explorerLink(payment)} rel="noreferrer">
          <Typography.Paragraph
            type="secondary"
            className="ant-typography-caption"
          >
            View on explorer <ExportOutlined />
          </Typography.Paragraph>
        </a>
      </Space>
    </>
  );
};
